/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */
/**
 * <p>Represents the differernt type of objects like File, Folder etc
 * FILE - Represents a file object
 * FOLDER - Represents a folder object<\/p>
 **/
export var ObjectType;
(function (ObjectType) {
    ObjectType["FILE"] = "FILE";
    ObjectType["FOLDER"] = "FOLDER";
})(ObjectType || (ObjectType = {}));
